export function getFuncSine(x: number, a: number, e: number, b: number, p: number) {
    return (a * Math.sin((b * x) + p)) + e;
}
